import { Component, effect } from '@angular/core';
import { SidebarService } from '@shared/services/sidebar.service';
import { CommonModule } from '@angular/common';
import { BackdropComponent } from '../backdrop/backdrop.component';
import { RouterModule } from '@angular/router';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { ModalHostComponent } from '@shared/components/ui/modal-host/modal-host.component';
import { UserPreferencesService, UserPreferences } from '@shared/services/usuario/user-preferences.service';
import { ThemeService } from '@shared/services/theme.service';
import { NavLayoutService } from '@shared/services/nav-layout.service';
import { AppSidebarMenuComponent } from '../app-sidebar/app-sidebar-menu/app-sidebar-menu.component';
import { AppTopNavComponent } from '../app-top-nav/app-top-nav.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    AppHeaderComponent,
    BackdropComponent,
    ModalHostComponent,
    AppSidebarMenuComponent,
    AppTopNavComponent,
  ],
  templateUrl: './app-layout.component.html',
})
export class AppLayoutComponent {
  readonly isExpanded$;
  readonly isHovered$;
  readonly isMobileOpen$;

  /** Disposición del menú activa (`sidebar` | `topnav`) — controla el template. */
  readonly navLayout;

  constructor(
    public sidebarService: SidebarService,
    private userPreferencesService: UserPreferencesService,
    private themeService: ThemeService,
    private navLayoutService: NavLayoutService
  ) {
    this.isExpanded$ = this.sidebarService.isExpanded$;
    this.isHovered$ = this.sidebarService.isHovered$;
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
    this.navLayout = this.navLayoutService.mode;

    // Cargar preferencias locales primero (tema; la disposición del menú ya la autoinicializa
    // NavLayoutService desde su propia clave de localStorage, aplicándose sin parpadeo en F5).
    const localPrefs = localStorage.getItem('userPreferences');
    if (localPrefs) {
      const prefs: UserPreferences = JSON.parse(localPrefs);
      if (prefs.theme === 'light' || prefs.theme === 'dark') {
        this.themeService.setTheme(prefs.theme);
      }
      if (prefs.navLayout) {
        this.navLayoutService.setMode(prefs.navLayout);
      }
    }

    // Efecto que escucha el signal del servicio y reconcilia con la preferencia del backend
    effect(() => {
      const prefs = this.userPreferencesService.preferences();

      if (prefs?.theme === 'light' || prefs?.theme === 'dark') {
        this.themeService.setTheme(prefs.theme);
      }
      if (prefs?.navLayout) {
        this.navLayoutService.setMode(prefs.navLayout);
      }
      if (prefs) {
        localStorage.setItem('userPreferences', JSON.stringify(prefs));
      }
    });

    // Pedir preferencias al backend para sincronizar
    this.userPreferencesService.getPreferences().subscribe({
      // Sin preferencias del backend se mantienen las locales (ya aplicadas).
      error: () => undefined,
    });
  }

  get containerClasses() {
    return [
      'flex-1',
      'transition-all',
      'duration-300',
      'ease-in-out',
      (this.isExpanded$ || this.isHovered$) ? 'xl:ml-[290px]' : 'xl:ml-[90px]',
      this.isMobileOpen$ ? 'ml-0' : ''
    ];
  }
}